import TrendingDistributionPerformanceCard from './trendingDistributionPerformanceCard.component';

export default TrendingDistributionPerformanceCard;